const defaults = {
    BASE_URL: process.env.REACT_APP_BASE_URL,
    GA_ID: process.env.REACT_APP_GA_ID,
    API_URL: process.env.REACT_APP_API_URL,
    API_TOKEN: process.env.REACT_APP_API_TOKEN,
};

export const getEnv = (name) => defaults[name];
